<template>
  <div class="cms-image-list">
    <ul :style="itemListStyles" class="u-reset cms-image-list__item-list">
      <li
        v-for="(imageItem, imageItemIdx) in imageItemList"
        :key="imageItemIdx"
        class="cms-image-list__item"
      >
        <figure class="cms-image-list__figure">
          <figcaption v-if="imageItem.imageCaption" class="cms-image-list__image-caption">
            {{ imageItem.imageCaption }}
          </figcaption>
          <component
            :is="getImageWrapperComponent(imageItem)"
            v-bind="getImageWrapperProps(imageItem)"
            :style="getImageWrapperStyles(imageItem)"
            class="u-reset cms-image-list__image-wrapper"
          >
            <responsive-img
              :src="imageItem.cmsImage"
              :style="getImageStyles(imageItem)"
              :width="500"
              alt=""
              class="cms-image-list__image"
              loading="lazy"
            />
          </component>
        </figure>
      </li>
    </ul>
  </div>
</template>

<script>
  import ResponsiveImg from '~/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg },
    props: {
      imageItemList: {
        type: Array,
        required: true,
      },
    },
    computed: {
      itemListStyles() {
        return {
          '--num-items': `${this.imageItemList.length}`,
        }
      },
    },
    methods: {
      getImageWrapperComponent(imageItem) {
        return imageItem.imageLink ? 'a' : 'span'
      },
      getImageWrapperProps(imageItem) {
        return {
          href: imageItem.imageLink,
          rel: 'noopener noreferrer',
          target: '_blank',
        }
      },
      getImageWrapperStyles(imageItem) {
        return {
          'align-items': imageItem.imageAlignment ? imageItem.imageAlignment : 'center',
          'justify-content': imageItem.imageJustification ? imageItem.imageJustification : 'center',
        }
      },
      getImageStyles(imageItem) {
        return {
          'max-width': imageItem.imageMaxWidth ? `${imageItem.imageMaxWidth}px` : '',
        }
      },
    },
  }
</script>

<style lang="scss" src="./_cms-image-list.scss" />
